import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import { BannerLayout } from './BannerLayout';
import s from './AllPlansIncludedFeaturesBanner.scss';

const BANNER_HEIGHT = '24px';
const BANNER_WIDTH = '674px';

const useGetAllPlansIncludedFeatures = () => {
  const p3Context = PremiumPurchasePlatformModule.internals.useContext();
  return PremiumPurchasePlatformModule.SDK.ApiClient.hooks.useGetAllPlansIncludedFeatures(
    p3Context,
  );
};

export const AllPlansIncludedFeaturesBanner = ({
  features,
}: {
  features?: string[];
}) => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();
  const { data, isLoading } = useGetAllPlansIncludedFeatures();

  if (isLoading && !features) {
    return (
      <Box align="center" width="100%">
        <SkeletonGroup className={s.gradientFill}>
          <SkeletonRectangle height={BANNER_HEIGHT} width={BANNER_WIDTH} />
        </SkeletonGroup>
      </Box>
    );
  }

  const items =
    features ?? data?.features?.map((item) => t(item.featureName ?? '')) ?? [];

  return (
    <BannerLayout
      title={t('premium-purchase-plan.header.all_premium_plans_include.title')}
      items={items}
    />
  );
};
